import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { AboutUsPage } from './pages/about-us/about-us';
import { AboutUsPageFull } from './pages/about-us/about-us.full';
import { AboutUsCommon } from './pages/about-us/about-us.common';
import { AboutUsData }from'./providers/about-us-data';

//Export
export { AboutUsPage } from './pages/about-us/about-us';
export { AboutUsPageFull } from './pages/about-us/about-us.full';

@NgModule({
    imports: [
        IonicModule,
    ],
    declarations: [
        AboutUsPage,
        AboutUsPageFull,
        
    ],
    exports: [
        AboutUsPage,
        AboutUsPageFull,
        
    ],
    bootstrap: [],
    entryComponents: [
        AboutUsPage,
        AboutUsPageFull,
        
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, AboutUsData, AboutUsCommon]
})
export class AboutUsModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: AboutUsPage, fullComponent: AboutUsPageFull, name: 'About Us Page', segment: 'about-us' },
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/about-us/about-us.module.ts